import React, { useState, useEffect, useRef } from "react";
import classes from "./Select.module.scss";
import * as helpers from "../../../helpers/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const Select = ({
  options,
  active: initialActive,
  dark,
  huge,
  large,
  className = "",
  auxKey = "",
  showLog = false,
  auxActive = null,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [activeSorterBy, setActiveSorterBy] = useState("");

  const sectionRef = useRef(null);
  useOutsideAlerter(sectionRef);

  // useEffect(() => {
  //   if (initialActive) {
  //     setActiveSorterBy(initialActive);
  //   }
  // }, [setActiveSorterBy, initialActive]);
  /**
   * Hook that alerts clicks outside of the passed ref
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
      let mounted = true;
      function handleClickOutside(event) {
        if (mounted && ref.current && !ref.current.contains(event.target))
          setIsOpen(false);
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
        mounted = false;
      };
    }, [ref]);
  }

  const onClickOrderByHandler = (option) => {
    setIsOpen(!isOpen);
  };

  const keyPresed = (event) => {
    if (event.key === "Escape") {
      setIsOpen(false);
    }
  };

  const clickFunc = (func, value) => {
    setActiveSorterBy(value);
    return func;
  };

  /**
   * Atention -
   * () => clickFunc(option.func, option.value)()
   */
  const getOptionsHandler = (options) => {
    return options.map((option) => {
      const value = option.value ? t(option.value) : "";
      const key = helpers.getKeyGen(option.value);
      const optClass =
        activeSorterBy === option.value
          ? classes.Option + " " + classes.ActiveOption
          : classes.Option;
      const func = option.func
        ? () => clickFunc(option.func, option.value)()
        : () => {};
      return (
        <button
          key={helpers.getKeyGen(key)}
          className={optClass}
          tabIndex="0"
          onClick={func}
        >
          {value}
        </button>
      );
    });
  };

  useEffect(() => {
    if (auxActive) {
      setActiveSorterBy(auxActive);
    }
  }, [auxActive]);

  let _items = options ? getOptionsHandler(options) : null;

  let classesDropdownList = isOpen
    ? classes.Dropdown + " " + classes.Open
    : classes.Dropdown;
  if (dark) classesDropdownList += " " + classes.Dark;
  if (huge) classesDropdownList += " " + classes.Huge;
  if (large) classesDropdownList += " " + classes.Large;
  if (className) classesDropdownList += " " + className;
  let titleActiveSorterBy = " - ";

  if (activeSorterBy === "") {
    if (initialActive) {
      setActiveSorterBy(initialActive);
    } else if (helpers.checkListSize(options)) {
      setActiveSorterBy(options[0].value);
    } else {
      titleActiveSorterBy = activeSorterBy;
    }
  } else if (activeSorterBy) {
    titleActiveSorterBy = activeSorterBy;
  } else if (initialActive) {
    titleActiveSorterBy = initialActive;
  }

  return (
    <section
      key={helpers.getKeyGen(activeSorterBy + auxKey)}
      ref={sectionRef}
      className={classesDropdownList}
      onClick={() => onClickOrderByHandler()}
      onKeyDown={(event) => keyPresed(event)}
    >
      <button tabIndex="0" className={classes.Active}>
        <span key={titleActiveSorterBy}>{t(titleActiveSorterBy)}</span>
        <FontAwesomeIcon className={classes.Icon} icon={faAngleDown} />
      </button>
      <div className={classes.DropdownList}>
        <div className={classes.Select}>{_items}</div>
      </div>
    </section>
  );

};

export default Select;
